export const routes = {
  landing: '/',
  app: '/app',
  contact: '/app/contact',
  payment: '/app/payment',
  success: '/app/success',
  results: (id: string) => `/app/results/${id}`,
} as const;
